import React, { PureComponent } from 'react';
import { reportError } from 'src/utils';

class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, { componentStack }) {
    reportError(error, componentStack);
  }

  render() {
    if (this.state.hasError) {
      return 'Something went wrong! Try to refresh the page.';
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
